const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 35V39.9992",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 17V29.9992",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 17V29.9992",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 36V38",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 34V41",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 48C46 45.2386 43.7614 43 41 43C38.2386 43 36 45.2386 36 48M36 48C36 46.3431 34.6569 45 33 45C32.0444 45 31.1931 45.4468 30.6438 46.1429C29.9065 44.301 28.1052 43 26 43C23.9681 43 22.2192 44.2121 21.437 45.9526C20.7389 44.7832 19.4609 44 18 44C16.5085 44 15.2076 44.8163 14.5199 46.0266C14.0652 45.4043 13.3298 45 12.5 45C11.1193 45 10 46.1193 10 47.5L36 48ZM10 48C10 45.7909 8.20914 44 6 44C3.79086 44 2 45.7909 2 48H10Z",
  stroke: "#495C6B",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 3L37 32H32.0443L32.0185 30H28.027L28.0447 32H20.0243L19.9953 30H16.0399L16.0058 32H11L24 3Z",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 22C25.6569 22 27 20.6569 27 19C27 17.3431 25.6569 16 24 16C22.3431 16 21 17.3431 21 19C21 20.6569 22.3431 22 24 22Z",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 24C4.08985 24 7 26.9101 7 30.5C7 32.8928 5.70712 34.9835 3.78183 36.1119C3.92347 36.5491 4 37.0156 4 37.5C4 39.9853 1.98528 42 -0.5 42",
  stroke: "#495C6B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 24C44.134 24 41 27.134 41 31C41 34.866 44.134 38 48 38",
  stroke: "#495C6B",
  strokeWidth: 2
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})));
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.a0f1a0b5.svg";
export { ForwardRef as ReactComponent };